import sign from './sign'

export default [sign]
